import SelectLanguage from "../../components/SelectLanguage";
import { SelectTheme } from "../../components/SelectTheme";
import { useLanguage } from "../../context/LanguageContext";
import { SidebarTrigger } from "../../components/ui/sidebar";
import NavUser from "./../../components/nav-user";
import NotificationBell from "../Notifications/_components/NotificationBell";

export default function AdminHeader() {
  const { language } = useLanguage();

  return (
    <>
      <div
        className="px-5 h-14 flex items-center gap-2 justify-between border-b"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        <SidebarTrigger />
        <div className="flex items-center gap-2">
          <NotificationBell />
          <NavUser />
          <SelectLanguage />
          <SelectTheme />
        </div>
      </div>
    </>
  );
}
